import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ta from "time-ago";
import { DeviceGroupSelect, EditableLabel } from "..";
import Icon from "../widgets/Icon/index";
import { Switch, Button } from "signoxe/components/widgets";
import {
  addDeviceUngroupedWrapers,
  addDeviceGroup,
} from "../../actions";
import { deleteDeviceGroup } from "../../actions";
import Dropdown, {
  DropdownContent,
  DropdownTrigger,
} from "react-simple-dropdown";
import {
  getPlaylistsV2,
} from "../../selectors";
import { getProfile } from "../../selectors";

import Popup from "signoxe/components/widgets";

import "./styles.scss";

const REBOOT_COMMAND = "reboot";

const UngropedDeviceView = ({
  device,
  groupList,
  dropdownGroups,
  deviceGroup,
  onChange,
  reportCall,
  screenshotsEnabled,
  deviceReportEnabled,
  offlineEnabled,
  delayDownloadEnabled,
  rebootEnabled,
  rebootDevice,
  addDeviceUngroupedWrapers,
  deleteDeviceGroup,
  optionComponent,
  toggleDeviceId,
  playlistOptions,
  profile,
}) => {
  const offlineOnly = localStorage.getItem('offlineOnly')
  var activePlaylist = "Choose playlists"


  const multiRegionEnabled =
  profile &&
  profile.features &&
  profile.features.multiregion &&
  profile.multiregion_switch === true;

  deviceGroup.feed_chain.filter((feed) => feed.id == deviceGroup.feed.id).map((feed) => {
    multiRegionEnabled?
    activePlaylist = feed.channel_details.name
    :
    playlistOptions?
      playlistOptions.map((option, index) => {
        if(feed.media_playlist == option.id){
          activePlaylist = option.name
        } 
      })
    : activePlaylist = "Choose playlists"
    })

  const setUngroup = () => {
    addDeviceUngroupedWrapers({ name: `divice_ungrouped_wraper_for_${device.name}`, deviceId: device.id })
  }

  const showText=(text) => {
    return <span className='show-text'>{text}</span>
  }

  console.log("Is it here",offlineOnly)
  
  if(offlineOnly ==='false'){
    return ( 
    <tr
      className={classNames("device-view depth-1", {
        disabled: !device.enabled,
        debug: device.debug_mode,
      })}
    >
      <td className="device-name" style={{display:'flex', justifyContent:'space-between'}}>
        <span className="hide-for-small-only">
          <EditableLabel
            value={device.name}
            onChange={(newVal) => onChange({ ...device, name: newVal })}
          />
        </span>
        <span className="show-for-small-only">
          {device.name} <strong>pinged</strong> {ta.ago(device.last_ping)}{" "}
        </span>
        <span className="show-for-small-only">
          {optionComponent(
            rebootEnabled && (
              <td className="">
                <span onClick={() => rebootDevice(device)} className='device-action-icon'>
                  <span>Reboot</span>
                  <Icon
                    title='Reboot '
                    name="refresh "
                    size="1rem"

                  />
                </span>
              </td>
            ), device
          )}
        </span>
      </td>
      {screenshotsEnabled && (
        <td className="screen-shots hide-for-small-only">
          <span className="show-for-small-only">Screenshots:</span>
          <Link to={`devices/${device.id}`}>
            <Icon title="Screenshots" name="picture-o" />
          </Link>
        </td>
      )}

      {offlineEnabled && (
        <td className="device-offline hide-for-small-only">
          <div
            style={{ margin: "0px", display: 'tableCell', verticalAlign: 'middle'}}
            onClick={() => onChange({ id: device.id, device_status: device.device_status=='online'? 'offline' : 'online' })}
          >
            <Switch checked={device.device_status != 'online'} size="tiny" />
          </div>
        </td>
      )}

      {delayDownloadEnabled &&(
        <td className="last-ping">
          <strong className="show-for-small-only">Device State: </strong>
          {device.device_state}
        </td>)}

      <td className="last-ping hide-for-small-only">
        <strong className="show-for-small-only">Last Ping: </strong>
        {ta.ago(device.last_ping)}
      </td>
      
      <td className="manage-content">
        <span onClick={() => toggleDeviceId(deviceGroup.id)} className='device-action-icon'>
          <Icon
            title='Manage Content'
            name="play"
            size="1rem"
          />
          <span className="text-ellipsis" >{activePlaylist}</span> 
        </span>
      </td>
      
      <td className="device-reboot hide-for-small-only">
        {optionComponent(
          rebootEnabled && (
            <div className="device-reboot" onClick={() => rebootDevice(device)}>
              <span  className='device-action-icon'>
                <span className='show-text'>Reboot</span>
                <Icon
                  title='Reboot '
                  name="refresh "
                  size="1rem"

                />
              </span>
            </div>
          ), device
        )}
      </td>
      <td className="change-group">
        <DeviceGroupSelect
          groups={dropdownGroups}
          selected={device.group}
          setUngroup={false}
          onChange={async (grpId) => {
            await onChange({ id: device.id, group: grpId })
            await deleteDeviceGroup(deviceGroup.id)
          }}
        />
      </td>
    </tr>)
  }else{
    return(
    <tr
      className={classNames("device-view depth-1", {
        disabled: !device.enabled,
        debug: device.debug_mode,
      })}
    >
      <td className="device-name" style={{display:'flex', justifyContent:'space-between'}}>
        <span className="hide-for-small-only">
          <EditableLabel
            value={device.name}
            onChange={(newVal) => onChange({ ...device, name: newVal })}
          />
        </span>
        <span className="show-for-small-only">
          {device.name} 
        </span>
      </td>
      
      <td className="change-group">
        <DeviceGroupSelect
          groups={dropdownGroups}
          selected={device.group}
          setUngroup={false}
          onChange={async (grpId) => {
            await onChange({ id: device.id, group: grpId })
            await deleteDeviceGroup(deviceGroup.id)
          }}
        />
      </td>
      <td>
        {optionComponent(
          rebootEnabled && (
            <td className="device-reboot">
              <span onClick={() => rebootDevice(device)} className='device-action-icon'>
                <span className='show-text'>Reboot</span>
                <Icon
                  title='Reboot '
                  name="refresh "
                  size="1rem"

                />
              </span>
            </td>
          ), device
        )}
      </td>
    </tr>)
  }
  
  
}

UngropedDeviceView.propTypes = {
  device: PropTypes.object.isRequired,
  screenshotsEnabled: PropTypes.bool,
  reportCall: PropTypes.func.isRequired,
  deviceReportEnabled: PropTypes.bool,
  groupList: PropTypes.array.isRequired,
  deviceGroup: PropTypes.object.isRequired,
  dropdownGroups: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  optionComponent: PropTypes.func.isRequired,
  toggleDeviceId: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
};
const mapStateToProps = state => ({
  playlistOptions: getPlaylistsV2(state),
  offlineOnly: state.authState.offlineOnly,
  profile: getProfile(state),

})

export default connect(
  mapStateToProps,
  {
    deleteDeviceGroup,
    addDeviceUngroupedWrapers,
    addDeviceGroup,
  }
)(UngropedDeviceView);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/UngropedDeviceView/index.js